import ScrollReveal from '@/components/ScrollReveal';
import { ShieldCheck, Camera, Clock, Award } from 'lucide-react';

const REASONS = [
  { icon: ShieldCheck, title: 'Evidence-Ready Reports', desc: 'Detailed, photographic reports made to be used as evidence in deposit disputes.' },
  { icon: Camera, title: 'Time-Stamped Photos', desc: 'Every on-site photograph is time-stamped for undisputed evidence.' },
  { icon: Clock, title: '24–48 Hour Turnaround', desc: 'Reports delivered within 24 to 48 hours, or within 4 hours with express.' },
  { icon: Award, title: 'Experienced & Insured', desc: 'Experienced clerks, backed by professional indemnity and public liability insurance.' },
];

export default function CampaignWhyUs() {
  return (
    <section className="py-16 md:py-32">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <ScrollReveal>
          <div className="text-center mb-16">
            <p className="caps-label text-orange mb-4">Why Choose Us</p>
            <h2 className="font-display font-extrabold text-navy" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
              The accredited inventory specialists
            </h2>
            <div className="w-16 h-1 bg-orange mx-auto mt-6" />
          </div>
        </ScrollReveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {REASONS.map((r, i) => (
            <ScrollReveal key={r.title} delay={i * 0.1}>
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-navy text-orange mb-6">
                  <r.icon size={28} />
                </div>
                <h3 className="font-semibold text-navy mb-3">{r.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{r.desc}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}